import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IState, IResultEntity, IDataEntity, IDataEntityResponse, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, ISearch, IAppParams, IPageProperties } from "../models";
import { MiniFundFinder } from "../components/MiniFundFinder";
import { toggleLoading } from "../actions/loading";
import { isNullOrUndefined } from "../utils";
import { getShareClassAndFund, getFunds, getFilters, changeFilter, toggleFund, toggleShareClass, toggleAllFunds, toggleShareClassPerformance } from "../actions";
import { BASE_SEARCH_REQUEST } from '../data/search';
import { isNullOrEmpty } from '../utils/collection';
import { LoadingIcon } from "../assets/LoadingIcon/LoadingIcon";

@connect(mapStateToProps, mapDispatchToProps)
export class MiniFundFinderContainer extends React.Component<React.Props<{}> & IPageProperties, {}>{
	componentWillMount() {
		this.props.getFunds(Object.assign({}, BASE_SEARCH_REQUEST, { limit: 1000 }), this.props.appParams, true);
		this.props.getFilters({}, this.props.appParams);
		this.props.changeFilter({
			search: []
		}, this.props.appParams);
	}

	render() {
		let { funds, filterOptions, changeFilter, filter, appParams, typeahead, isLoading } = this.props;

		if (isNullOrUndefined(typeahead)) {
			return <LoadingIcon isLoading={ true } styles={ { paddingTop: "0", marginTop: "-30px", backgroundColor: "transparent" } } />;
		}

		return (
			<MiniFundFinder
				funds={ funds }
				filterOptions={ filterOptions }
				changeFilter={ changeFilter }
				filter={ filter }
				typeahead={ typeahead }
				appParams={ appParams }
				isLoading={ isLoading }>
			</MiniFundFinder>
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IPageProperties {
	return {
		funds: state.funds,
		filterOptions: state.filterOptions,
		filter: state.filter,
		typeahead: state.typeahead,
		isLoading: state.loading.isLoading
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IPageProperties {
	return {
		getShareClassAndFund: bindActionCreators(getShareClassAndFund, dispatch),
		changeFilter: bindActionCreators(changeFilter, dispatch),
		getFunds: bindActionCreators(getFunds, dispatch),
		getFilters: bindActionCreators(getFilters, dispatch)
	};
}


// WEBPACK FOOTER //
// ./src/client/containers/MiniFundFinderContainer.tsx